import React from "react";
import "../style.css";

export default class CardCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "Kategorie",
      titel: props.titel,
      image: props.image
    };
  }

  render() {
    return (
      <div className="category">
        <div  className="body" style={{padding: "1rem"}}>
          <img src={this.state.image} style={{height: "100%", objectFit: "cover"}} className="image"/>
          <div 
            style={{
              display: "flex", 
              flexDirection: "column",
              gap: "0.2rem"
            }}>
            <div style={{ whiteSpace: 'pre-line'}} className="h5">{this.state.type}</div>
            <div style={{ whiteSpace: 'pre-line'}} className="bodycopy">{this.state.titel}</div>
          </div>
        </div>
      </div>
    );
  }
}